module.exports = __webpack_public_path__ + "static/media/monthlyPLAnalaysis_ja_light_large.eb58565f.png";